<template>
  <div class="relate">
    <div class="relate_container">
      <div class="relate_container_storys">

        <div class="relateRow relateRow-1">
          <div class="relate_container_storys_item relate_container_storys_item-first" 
          :class="{'relate_container_storys_item-active': isActive1}" 
          @click="click_GA(1)">
            <a class="relate_container_storys_item_link" :href="this.href1" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image1" :alt="text1">
              </div>
              <p class="relate_container_storys_item_link_description">{{text1}}</p>
            </a>
          </div>

          <div class="relate_container_storys_item" :class="{'relate_container_storys_item-active': isActive2}"
          @click="click_GA(2)">
            <a class="relate_container_storys_item_link" :href="this.href2" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image2" :alt="text2">
              </div>
              <p class="relate_container_storys_item_link_description">{{text2}}</p>
            </a>
          </div>
        </div>
        
        <div class="relateRow relateRow-2">
          <div class="relate_container_storys_item" :class="{'relate_container_storys_item-active': isActive3}"
          @click="click_GA(3)">
            <a class="relate_container_storys_item_link" :href="this.href3" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image3" :alt="text3">
              </div>
              <p class="relate_container_storys_item_link_description">{{text3}}</p>
            </a>
          </div>

          <div class="relate_container_storys_item" :class="{'relate_container_storys_item-active': isActive4}"
          @click="click_GA(4)">
            <a class="relate_container_storys_item_link" :href="this.href4" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image4" :alt="text4">
              </div>
              <p class="relate_container_storys_item_link_description">{{text4}}</p>
            </a>
          </div>

          <div class="relate_container_storys_item" :class="{'relate_container_storys_item-active': isActive5}"
          @click="click_GA(5)">
            <a class="relate_container_storys_item_link" :href="this.href5" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image5" :alt="text5">
              </div>
              <p class="relate_container_storys_item_link_description">{{text5}}</p>
            </a>
          </div>
        </div>

        <div class="relateRow relateRow-3">
          <div class="relate_container_storys_item relate_container_storys_item-last" 
          :class="{'relate_container_storys_item-active': isActive6}" 
          @click="click_GA(6)">
            <a class="relate_container_storys_item_link" :href="this.href6" target="_blank">
              <div class="relate_container_storys_item_link_image">
                <img :src="image6" :alt="text6">
              </div>
              <p class="relate_container_storys_item_link_description">{{text6}}</p>
            </a>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import Utils from 'udn-newmedia-utils'

export default {
  name: 'Relate',
  props: {
    preHref: {
      String,
      default: '../'
    },
    image1: {
      String,
      default: require('./../general_images/r1_921_people_children.jpg')
    },
    image2: {
      String,
      default: require('./../general_images/r2_921_rebuild.jpg')
    },
    image3: {
      String,
      default: require('./../general_images/r3_921_live.jpg')
    },
    image4: {
      String,
      default: require('./../general_images/r4_921_resilientcity.jpg')
    },
    image5: {
      String,
      default: require('./../general_images/r5_921_safehome.jpg')
    },
    image6: {
      String,
      default: require('./../general_images/r6_921_memory.jpg')
    },
    text1: {
      String,
      default: '921地震孤兒長大了'
    },
    text2: {
      String,
      default: '堅持20年的重建路'
    },
    text3: {
      String,
      default: '建築耐震總體檢'
    },
    text4: {
      String,
      default: '921再震一次 台灣準備好了嗎'
    },
    text5: {
      String,
      default: '你家耐震嗎？'
    },
    text6: {
      String,
      default: '寫一封信給921'
    },
    isActive1: Boolean,
    isActive2: Boolean,
    isActive3: Boolean,
    isActive4: Boolean,
    isActive5: Boolean,
    isActive6: Boolean,
  },
  data() {
    return {
      href1: this.preHref + 'people/children/',
      href2: this.preHref + 'rebuild',
      href3: this.preHref + 'live/',
      href4: this.preHref + 'resilientcity/',
      href5: this.preHref + 'safehome/',
      href6: this.preHref + 'memory/'
    }
  },
  methods: {
    click_GA(number) {
      let label = null
      switch(number) {
        case 1:
          label = 'people'
          break;
        case 2:
          label = 'live'
          break;
        case 3:
          label = 'rebuild'
          break;
        case 4:
          label = 'resilientcity'
          break;
        case 5:
          label = 'aseismatic'
          break;
        case 6:
          label = 'memory'
          break;
      }
      window.ga('newmedia.send', 'event', {
        eventCategory: 'related',
        eventAction: 'click',
        eventLabel: `[${Utils.detectPlatform()}][${document.querySelector('title').innerHTML}][${label}]`
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.relate {
  margin: 60px 0;
  @media (min-width: 768px) and (max-width: 1279.98px) {
    margin: 100px 0;
  }
  @media (min-width: 1280px) {
    margin: 120px 0;
  }
}

.relateRow {
  margin: 0 auto;
  margin-right: -25px;
  margin-left: -25px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  &.relateRow-1 {
    justify-content: space-between;
  }
  &.relateRow-2 {
    justify-content: space-between;
    align-items: flex-start;
  }
  &.relateRow-3 {
    justify-content: center;
  }
}
.relate {
    width: 100%;
    background: black;
}
.relate_container {
    margin: 0 auto;
    width: 92%;
    @media (min-width: 768px) and (max-width: 1279.98px) {
        width: 80%;
    }
    @media (min-width: 1280px) {
        width: 50%;
    }
}
.relate_container_storys {
    width: 100%;
    padding-right: 25px;
    padding-left: 25px;
    box-sizing: border-box;
    @media (min-width: 768px) and (max-width: 1279.98px) {
      padding-right: 0px;
      padding-left: 0px;
    }
    @media (min-width: 1280px) {
      padding-right: 0px;
      padding-left: 0px;
    }
}

.relate_container_storys_item{
  width: 100%;
  margin: 0;
  margin-bottom: 60px;
  box-sizing: border-box;
  &.relate_container_storys_item-active {
    pointer-events: none;
    .relate_container_storys_item_link_image, .relate_container_storys_item_link_description {
      opacity: 0.4;
    }
  }
  &:hover {
    .relate_container_storys_item_link_image img {
      transform: scale(1.1);
    }
    .relate_container_storys_item_link_description {
      opacity: 0.7;
    }
  }
  @media (min-width: 768px) {
    width: 33.333333%;
    padding: 0 25px;
    margin-bottom: 50px;
  }
}

.relate_container_storys_item_link {
  text-decoration: none;
}

.relate_container_storys_item-first {
  position: relative;
  &:before {
    content: '看更多系列報導';
    display: inline-block;
    color: white;
    writing-mode: vertical-lr;
    position: relative;
    left: 25%;
    font-size: 20px;
    letter-spacing: 14px;
    margin-top: 100px;
    margin-bottom: 200px;
    top: 0px;
    white-space: nowrap;
  }
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    color: white;
    writing-mode: vertical-lr;
    height: 150px;
    border-left: 1px solid white;
    left: calc(25% + 11px);
    top: 350px;
  }
  @media (min-width: 768px) {
    &:before {
      content: '看更多系列報導';
      display: inline-block;
      color: white;
      writing-mode: vertical-lr;
      position: relative;
      left: calc(100% + 38px);
      font-size: 20px;
      letter-spacing: 14px;
      margin-top: 140px - 80px;
      top: 80px;
      margin-bottom: 0;
      white-space: nowrap;
    }
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      color: white;
      writing-mode: vertical-lr;
      height: 24%;
      border-left: 1px solid white;
      left: calc(100% + 25px);
      top: 380px;
    }
  }
  @media (min-width: 1280px) {
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      color: white;
      writing-mode: vertical-lr;
      height: 28%;
      border-left: 1px solid white;
      left: calc(100% + 25px);
      top: 380px;
    }
  }
}

.relate_container_storys_item-last {
  margin-bottom: 100px;
    @media (min-width: 768px) and (max-width: 1279.98px) {
      // margin-bottom: 140px;
    }
    @media (min-width: 1280px) {
      margin-bottom: 140px;
  }
}

.relate_container_storys_item_link_image {
  overflow: hidden;
  img {
    width: 100%;
    transition: 0.5s;
  }
}
.relate_container_storys_item_link_description {
  margin: 0;
  margin-top: 5px;
  color: white;
  font-size: 1.2rem;
  transition: 0.5s;
    @media (min-width: 768px) {
      font-size: 1.6rem;
  }
}
</style>
